import FilterBase from "../common/FilterBase.js"
import { updateMonthSelect } from "../common/common.js"
import { formatData } from "../common/FetchFilterData";
const url = "https://app.vantetider.se/spa/1.1/rest/filters/filterchoices/over90OperationFilter"

class over90Filter extends FilterBase {
    static get observedAttributes() {
        return super.observedAttributes.concat("regionarea");
    }

    constructor() {
        super();
        var firstDiv = "firstDiv";
        var secondDiv = "secondDiv";
        var thirdDiv = "thirdDiv";
        const selectorOptions = [
            {
                name: "productionSelect",
                button: true,
                header: "Kontaktstatus",
            },
            {
                name: "yearSelect",
                divName: firstDiv,
                header: "Välj år",
                startDown: true,
                events: [
                    {
                        name: "change",
                        callback: updateMonthSelect.bind(this)
                    }
                ]
            },
            {
                name: "monthSelect",
                divName: firstDiv,
                header: "Välj månad",
                startDown: true,
            },
            {
                name: "regionSelect",
                divName: secondDiv,
                multiple: true,
                attributes: {
                    defaultLabel: "Alla regioner"
                },
                header: "Välj region(er)",
            },
            {
                header: "Välj ägartyp",
                name: "ownerSelect",
                divName: secondDiv,
                data: ["Alla ägarformer", "Privat", "Offentlig"]
            },
            {
                name: "serviceSelect",
                divName: secondDiv,
                attributes: {
                    defaultLabel: "Alla vårdutbud"
                },
                header: "Välj Vårdutbud",
            }
        ]
        this.addSelectors(selectorOptions);
        this.addSubmitButton(
            {
                text: "Visa Statistik",
                divName: thirdDiv,
                submitName: "over90FilterSubmit",
                valueCallback: this.getSelectorValues.bind(this),
                textCallback: this.getSelectorTexts.bind(this)
            })
        this.addClearFilterButton({
            text: "Rensa",
            divName: thirdDiv
        })
        this.addDataToButtonSelect("productionSelect", [{ name: "Väntande", value: 0 }, { name: "Genomförda", value: 1 }]);
        this.addSearchRequestListener("over90SearchReq");
    }
    attributeChangedCallback(name, oldval, newval) {
        if (oldval !== newval) {
            if (name === "regionarea" || !this.regionArea) {
                this.regionArea = newval
                this.getData()
            }
        }
    }
    async getData() {
        if(!this.regionArea)
            return console.error("No region area set.")
        try {
            const res = await formatData({ regionArea: this.regionArea }, url);
            this.storedData = res;
            res.regions.unshift({
                name: "Alla regioner",
                value: -1
            })
            res.operations.unshift({
                name: "Alla vårdutbud",
                value: -1
            })
            this.addDataToSelect("regionSelect", res.regions);
            this.addDataToSelect("yearSelect", res.dates.years);
            updateMonthSelect.bind(this)();
            this.addDataToSelect("serviceSelect", res.operations);

            this.dispatchSubmitEvent("over90FilterSubmit", this.getSelectorValues.bind(this), this.getSelectorTexts.bind(this));
        } catch (error) {
            console.error(error);
        }
    }

    getFilterUrlParams() {
        return {
            production: this.getSelectValue("productionSelect") ? this.getSelectValue("productionSelect") : 0,
            measurementMonth: this.getSelectValue("monthSelect") ? this.getSelectValue("monthSelect") : "Januari",
            measurementYear: this.getSelectValue("yearSelect") ? this.getSelectValue("yearSelect") : "2021",
            regionArea: this.regionArea
        }
    }

    getSelectorValues() {
        return {
            production: this.selectors["productionSelect"].selectorObj.getSelected(),
            measurementMonth: this.getSelectValue("monthSelect"),
            measurementYear: this.getSelectValue("yearSelect"),
            regionArea: this.regionArea,
            regionIds: this.getSelectValue("regionSelect"),
            serviceId: this.getSelectValue("serviceSelect"),
            management: this.getSelectValue("ownerSelect")
        }
    }
    getSelectorTexts() {
        return {
            production: this.selectors["productionSelect"].selectorObj.getSelectedText(),
            month: this.getSelectText("monthSelect"),
            year: this.getSelectText("yearSelect"),
            regions: this.getSelectText("regionSelect") != "Alla regioner" ? this.getSelectText("regionSelect") : "Alla regioner inom sjukvårdområdet",
            service: this.getSelectText("serviceSelect"),
            management: this.getSelectText("ownerSelect"),
            indicator: "Totalt antal över 90 dagar"
        }
    }
}
if (!customElements.get("over90-filter")) {
    FilterBase.define("over90-filter", over90Filter);
}
